import { render, staticRenderFns } from "./couponEdit.vue?vue&type=template&id=4ea64c72&scoped=true&"
import script from "./couponEdit.vue?vue&type=script&lang=js&"
export * from "./couponEdit.vue?vue&type=script&lang=js&"
import style0 from "./couponEdit.vue?vue&type=style&index=0&id=4ea64c72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea64c72",
  null
  
)

export default component.exports